import React from 'react';
import { colors } from './settings.js';

export default class Gradients extends React.Component {
  render() {
    return (
      <defs>
        {
          Object.keys(colors).map(c => {
            return (
              <linearGradient
                key={c}
                id={c}
                x1='0%'
                x2='50%'
                y1='0%'
                y2='50%'
                gradientTransform={'skewX(45)'}
              >
                <stop offset='0%' stopColor={colors[c].dark} />
                <stop offset='33%' stopColor={colors[c].dark} />
                <stop offset='34%' stopColor={colors[c].light} />
                <stop offset='100%' stopColor={colors[c].light} />
              </linearGradient>
            )
          })
        }
      </defs>
    );
  }
}